// extracted by mini-css-extract-plugin
export var addToCartButton = "_sp-b";
export var arrowButtonContainer = "_sp-9";
export var arrowButtonIcon = "_sp-a";
export var carouselArrowButton = "_sp-6";
export var carouselElementContainer = "_sp-1";
export var galleryThumbnail = "_sp-d";
export var galleryThumbnailImage = "_sp-e";
export var left = "_sp-7";
export var productDisplayCarouselContainer = "_sp-0";
export var productTileContainer = "_sp-2";
export var productTileImage = "_sp-4";
export var productTileImageContainer = "_sp-3";
export var productTileTitle = "_sp-5";
export var right = "_sp-8";
export var sliderOverflow = "_sp-c";